<script lang="ts">
	import { Alert, Heading, Modal } from "flowbite-svelte";
	import { tick } from "svelte";
	import { twMerge } from "tailwind-merge";
	import Icon from "#lib/components/Icon.svelte";
	import type { ModalProps } from "flowbite-svelte/Modal.svelte";

	interface $$Props extends ModalProps {
		open: boolean;
		lastError?: unknown;
	}

	export let open = false;
	export let lastError: unknown = undefined;

	$: if (open) {
		tick().then(() => {
			const closeButton = document.querySelector<HTMLButtonElement>('button[aria-label="Close modal"]');
			if (closeButton) {
				closeButton.dataset.actionName = "modal-close";
				if ($$props.title) {
					closeButton.dataset.modalTitle = $$props.title;
				}
			}
		});
	}
</script>

<Modal class={twMerge("text-gray-800 dark:text-gray-200", $$props.class)} {...$$restProps} bind:open on:close>
	{#if lastError}
		<Alert color="red" border>
			<Icon class="flex-none" slot="icon" name="exclamation-triangle" />
			{lastError}
		</Alert>
	{/if}
	<svelte:fragment slot="header">
		{#if $$props.title}
			<Heading tag="h3" class="text-lg font-semibold">{$$props.title}</Heading>
		{:else}
			<slot name="header" />
		{/if}
	</svelte:fragment>
	<slot />
	<svelte:fragment slot="footer">
		<slot name="footer" />
	</svelte:fragment>
</Modal>
